/**
 * @generated SignedSource<<782bf861ad82593f1f7771059ba87d09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScreenersStudyStatusChoices = "CM" | "DR" | "LV" | "%future added value";
export type ScreenersStudyTypeChoices = "OO" | "SS" | "SY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AlertVoxpopmeVideoAnalysis_study$data = {
  readonly dId: any | null;
  readonly id: string;
  readonly name: string | null;
  readonly status: ScreenersStudyStatusChoices;
  readonly tenant: {
    readonly dId: any | null;
    readonly id: string;
    readonly name: string;
    readonly vpmAccountId: number | null;
  };
  readonly type: ScreenersStudyTypeChoices;
  readonly " $fragmentType": "AlertVoxpopmeVideoAnalysis_study";
};
export type AlertVoxpopmeVideoAnalysis_study$key = {
  readonly " $data"?: AlertVoxpopmeVideoAnalysis_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertVoxpopmeVideoAnalysis_study">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AlertVoxpopmeVideoAnalysis_study",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TenantNode",
      "kind": "LinkedField",
      "name": "tenant",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vpmAccountId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};
})();

(node as any).hash = "da170b628be50e0d31fc40adf3216db6";

export default node;
